import { render } from "./UploadEstudiantes.vue?vue&type=template&id=c01af96e&scoped=true"
import script from "./UploadEstudiantes.vue?vue&type=script&lang=js"
export * from "./UploadEstudiantes.vue?vue&type=script&lang=js"

import "../assets/bootstrap.min.css?vue&type=style&index=0&id=c01af96e&scoped=true&lang=css"
import "./UploadEstudiantes.vue?vue&type=style&index=1&id=c01af96e&scoped=true&lang=css"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c01af96e"]])

export default __exports__